<script>
    export default {
        name: "ProductCardIcons",
        props: {
            icons: [Object, Array],
        },
        computed: {
            sortedIcons() {
                return Object.entries(this.icons)
                    .sort(([, a], [, b]) => a.sort - b.sort)
                    .map((entry) => {
                        const [name, value] = entry;
                        return { name, ...value };
                    });
            },
        },
    };
</script>

<template>
    <div class="product-card-icons">
        <div
            class="product-card-icons__item"
            v-for="(icon, index) in sortedIcons"
            :key="index"
        >
            <img :src="`/static/ivideon/product/${icon.name}.svg`" alt="" />
            <span> {{ icon.value.replace(" (ivideon)", "") }}</span>
        </div>
    </div>
</template>

<style lang="scss">
    .product-card-icons {
        margin-bottom: -4px;
        color: var(--secondary-text);
        font-size: 10px;
        line-height: 10px;
        @include bp($bp-desktop-sm) {
            display: flex;
            flex-wrap: wrap;
            margin: 0 -15px -10px;
            font-size: 12px;
            line-height: 18px;
        }
    }

    .product-card-icons__item {
        display: flex;
        align-items: center;
        margin-bottom: 4px;
        @include bp($bp-desktop-sm) {
            margin: 0 15px 10px;
        }
        img {
            @include box(14px);
            margin-right: 2px;
            @include bp($bp-desktop-sm) {
                @include box(16px);
                margin-right: 4px;
            }
        }
    }
</style>
